<template>
  <div class="row login-normal-container mfa-text">
    <div class="col-lg-6 col-md-6 flex justify-center">
      <mfa-template>
        <template v-slot:svg>
          <div class="mfa-error"></div>
        </template>
        <template v-slot:header>
          <div class="mfa-main-title text-zt-primary-200 text-zt-xl font-medium mb-4">{{$t('message.mfa.max_exceeded_resend_fails_mails.title')}}</div>
        </template>
        <template v-slot:subtitle>
          <div class="text-zt-dark-400 font-weight-normal mb-2">
            <p v-if="isMaxResendFails">
              {{$t('message.mfa.max_exceeded_resend_fails_mails.sub_title_max_mails_resend_fails')}}
            </p>
            <p v-else>
              {{$t('message.mfa.max_exceeded_resend_fails_mails.sub_title_max_code_attempts')}}
            </p>
          </div>
        </template>
        <template v-slot:submitButtons>
          <div class="flex justify-end">
            <div class="w-1/2 mr-4">
              <zt-button class="text-zt-lg w-full" @click="$emit('backToLogin')" data-vs-button="button-mfa-msg-exceeded-back-login">{{$t('message.mfa.max_exceeded_resend_fails_mails.go_back_login_btn')}}</zt-button>
            </div>
          </div>
        </template>
      </mfa-template>
    </div>
    <div id="imageBackground" class="col-lg-6 col-md-6 flex justify-center">
      <div v-if="$browserDetect.isChrome" class="logo-desktop"></div>
      <div v-else>
        <img :src="`${baseUrl}assets/images/background-login.png`" class="logo-desktop-noChrome"/>
      </div>
    </div>
  </div>
</template>

<script>
import mfaTemplate from "./mfaTemplate";
export default {
  name: "mfaMessageExceededFails",
  components: {
    mfaTemplate
  },
  props: {
    isMaxResendFails: {
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">
  @import "./mfa.scss";
</style>